module.exports = __webpack_public_path__ + "static/img/BrandPredecessor.7eeb7cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BrandPredecessor.png
// module id = MdEf
// module chunks = 1